import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutomaticNumberingComponent } from './automatic-numbering/automatic-numbering.component';
import { MatDividerModule } from '@angular/material/divider';
import { PlaceOfIssueComponent } from './place-of-issue/place-of-issue.component';
import { SignaturesComponent } from './signatures/signatures.component';
import { NumberFormatComponent } from './number-format/number-format.component';
import { DocumentsSymbolsComponent } from './documents-symbols/documents-symbols.component';
import { NumberingTypeComponent } from './numbering-type/numbering-type.component';
import { DefaultCommentsComponent } from './default-comments/default-comments.component';
import { EnableGtuComponent } from './enable-gtu/enable-gtu.component';
import { EnablePkwiuComponent } from './enable-pkwiu/enable-pkwiu.component';
import { AutoAnnotationsComponent } from './auto-annotations/auto-annotations.component';
import { ShowKsefQrComponent } from './show-ksef-qr/show-ksef-qr.component';
import { ShowConvertedAmountComponent } from './show-converted-amount/show-converted-amount.component';
import { PriceInputModeComponent } from './price-input-mode/price-input-mode.component';
import { DefaultPaymentStatusComponent } from './default-payment-status/default-payment-status.component';

@Component({
  selector: 'app-autocomplete-settings',
  standalone: true,
  imports: [CommonModule, NumberingTypeComponent, AutomaticNumberingComponent, DocumentsSymbolsComponent, NumberFormatComponent, MatDividerModule, PlaceOfIssueComponent, DefaultCommentsComponent, SignaturesComponent, EnableGtuComponent, EnablePkwiuComponent, AutoAnnotationsComponent, ShowKsefQrComponent, ShowConvertedAmountComponent, PriceInputModeComponent, DefaultPaymentStatusComponent],
  templateUrl: './autocomplete-settings.component.html',
  styleUrl: './autocomplete-settings.component.scss'
})
export class AutocompleteSettingsComponent {

  @Input() settings = new Set<string>(['automaticNumbering', 'placeOfIssue', 'comments', 'signatures', 'numberFormat', 'documentsSymbols', 'numberingType', 'enableGTU', 'enablePKWiU', 'autoAnnotations', 'vatExemptionBase', 'showKsefQrCode', 'showConvertedAmount', 'priceInputMode', 'defaultPaymentStatus'])
}
